import { Injectable } from '@angular/core';
import { TableObject } from '../../../models/tableObject';
import { Observable } from 'rxjs';
import { NextValutationDate } from '../../../models/NextValutationDate';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConstantsStore } from '../constants.store';
import { TableFiltersDto } from 'src/app/models/TableFiltersDto';

@Injectable({
  providedIn: 'root'
})
export class NextValutationDateService {

  sortingFilter?: string;
  sortingAscending?: boolean;
  constructor(
    private http: HttpClient,
    private endpointsStore: ConstantsStore
  ) { }

  get(pageNumber: number, pageSize: number, filter: string, ascending: boolean): Observable<any> {
    return new Observable(observer => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .subscribe(
          (result: TableObject<NextValutationDate>) => {
            observer.next(result);
          },
          error => observer.error(error)
        );
    });
  }

  getAll(): Observable<any> {
    return new Observable(observer => {
      this.httpGetAll()
        .subscribe(
          (result: TableObject<NextValutationDate>) => {
            observer.next(result);
          },
          error => observer.error(error)
        );
    });
  }

  getForGuest(pageNumber: number, pageSize: number, filter: string, ascending: boolean): Observable<any> {
    return this.httpGetGuest(pageNumber, pageSize, filter, ascending);
  }

  getFilters(): Observable<any> {
    return new Observable(observer => {
      this.httpGetFilters()
      .subscribe(
        (dateRange: { [id: string]: Date[] }) => {
          observer.next(dateRange);
        },
        error => observer.error(error)
      );
    });
  }

  filter(filters : TableFiltersDto): Observable<any> {
    return new Observable(observer => {
      // const queryParams = new HttpParams()
      // .set('dateFrom', dateFrom.toString())
      // .set('dateTo', dateTo.toString());

      //console.log('FILTERS', filters);


      this.http.post(`${this.endpointsStore.nextValutationDateUrl}`, filters)
      .subscribe(
        (result: TableObject<NextValutationDate>) => {
          observer.next(result);
        },
        error => observer.error(error)
      );
    });
  }

  httpGet(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const nextValuationDateUrl = `${this.endpointsStore.nextValutationDateUrl}/${pageNumber}/${pageSize}${this.endpointsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<NextValutationDate>>(nextValuationDateUrl);
  }

  httpGetAll() {
    const nextValuationDateUrl = `${this.endpointsStore.nextValutationDateUrl}/All`;
    return this.http.get<TableObject<NextValutationDate>>(nextValuationDateUrl);
  }

  httpGetFilters() {
    const nextValuationDateUrl = `${this.endpointsStore.nextValutationDateUrl}/Filters`;
    return this.http.get<{ [id: string]: Date[] }>(nextValuationDateUrl);
  }


  httpGetGuest(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const nextValuationDateUrl = `${this.endpointsStore.nextValutationDateUrlGuest}/${pageNumber}/${pageSize}${this.endpointsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<NextValutationDate>>(nextValuationDateUrl);
  }

}
